import { message } from "antd";
import { errorModal } from "./modal";

export function getErrorMessage(err: any) {
	let errMessage = "Failed. Please try again.";
	console.info("err", err);

	if (err && typeof err === "string") {
		errMessage = err;
	} else if (err.status === 503 || err.status === 502) {
		errMessage = "Our server is temporarily unavailable. Please try again later.";
	} else if (err && err.response) {
		if (err.response.data && err.response.data.message) {
			errMessage = err.response.data.message;
		} else if (err.response.message) {
			errMessage = err.response.message;
		} else {
			errMessage = JSON.stringify(err);
		}
	} else if (err && err.data) {
		if (err.data && err.data.message) {
			errMessage = err.data.message;
		} else {
			errMessage = JSON.stringify(err);
		}
	} else if (err.message) {
		if (typeof err.message == "string") {
			errMessage = err.message;
		} else if (typeof err.message.message == "string") {
			errMessage = err.message.message;
		} else {
			errMessage = JSON.stringify(err.message);
		}
	} else if (err.statusText) {
		errMessage = err.statusText;
	} else {
		errMessage = JSON.stringify(err);
	}

	if (errMessage.toLowerCase().includes("remaining connection slots")) {
		return "Our servers are temporarily at maximum capacity. Please try again shortly.";
	} else {
		return errMessage;
	}
}

export function showErrorMessage(err: any, isModal: boolean, isRefresh?: boolean) {
	const msg = getErrorMessage(err);

	if (err?.response?.status === 403 || err?.status === 403) {
		const unauthorizedMsg = "Unauthenticated (403). Please login again.";

		if (isModal) {
			errorModal({
				title: "Session Expired",
				subtitle: unauthorizedMsg,
			});
		} else {
			message.error(unauthorizedMsg);
		}

		return;
	}

	if (isModal) {
		// Modal
		errorModal({
			title: "Failed",
			subtitle: msg,
			onCancel() {
				if (isRefresh) {
					window.location.reload();
				}
			},
		});
	} else {
		message.error(msg);
	}
}
